import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
import MySelect from '@/components/MySelect.vue';
let CharacterSheetEquipmentCustomAdder = class CharacterSheetEquipmentCustomAdder extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.name = '';
        this.equipmentCategory = 'Gear';
        this.quantity = 1;
        this.cost = 0;
        this.description = '';
        this.weight = 1;
        this.damageType = 'Kinetic';
        this.dieSize = 4;
        this.toHit = 0;
        this.damage = 0;
        this.equipped = false;
        this.damageNumberOfDice = 1;
    }
    get isEquippable() {
        return ['Weapon', 'Armor'].includes(this.equipmentCategory);
    }
    get dieSizes() {
        return [4, 6, 8, 10, 12].map(value => ({ text: 'd' + value, value }));
    }
    resetValues() {
        this.equipmentCategory = 'Gear';
        this.quantity = 1;
        this.equipped = false;
        this.damageType = 'Kinetic';
        this.description = '';
        this.weight = 1;
        this.cost = 0;
        this.name = '';
        this.toHit = 0;
        this.damage = 0;
        this.damageNumberOfDice = 1;
        this.dieSize = 4;
    }
    addItem() {
        this.$emit('updateCharacter', { customEquipment: { [this.position]: {
                    name: this.name,
                    quantity: this.quantity,
                    equipmentCategory: this.equipmentCategory,
                    cost: this.cost,
                    description: this.description,
                    weight: this.weight,
                    ...(this.equipmentCategory === 'Weapon' ? {
                        damageType: this.damageType,
                        damageNumberOfDice: this.damageNumberOfDice,
                        tweaks: {
                            toHit: { override: this.toHit },
                            damageDice: { dieSize: this.dieSize },
                            damage: { override: this.damage }
                        }
                    } : {}),
                    ...(this.isEquippable ? { equipped: this.equipped } : {})
                } } });
        this.isOpen = false;
    }
};
__decorate([
    Prop(Number)
], CharacterSheetEquipmentCustomAdder.prototype, "position", void 0);
CharacterSheetEquipmentCustomAdder = __decorate([
    Component({
        components: {
            MyDialog,
            MySelect
        }
    })
], CharacterSheetEquipmentCustomAdder);
export default CharacterSheetEquipmentCustomAdder;
